import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './DynamicPage.css';

function DynamicPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPage();
  }, [slug]);

  const loadPage = async () => {
    try {
      setLoading(true);
      const path = window.location.pathname;
      const response = await axios.get(`/api/menu${path}`);
      
      if (response.data && response.data.type === 'page') {
        setPage(response.data);
      } else {
        navigate('/');
      }
      
      setLoading(false);
    } catch (error) {
      console.error('Error loading page:', error);
      navigate('/');
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Φόρτωση...</p>
      </div>
    );
  }

  if (!page || !page.pageContent) {
    return null;
  }

  return (
    <div className="dynamic-page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-title">{page.pageContent.title}</h1>
          {page.pageContent.subtitle && (
            <p className="page-subtitle">{page.pageContent.subtitle}</p>
          )}
        </div>
      </div>

      <div className="container">
        <div className="page-content">
          {page.pageContent.sections && page.pageContent.sections.map((section, index) => (
            <div key={index} className={`content-section ${section.type}`}>
              {section.type === 'text' && (
                <div className="text-content">
                  <p>{section.content}</p>
                </div>
              )}
              
              {section.type === 'hero' && (
                <div className="page-hero-content">
                  <p>{section.content}</p>
                </div>
              )}

              {section.type === 'image' && (
                <div className="image-content">
                  <img src={section.url} alt={section.alt || ''} />
                  {section.caption && <p className="image-caption">{section.caption}</p>}
                </div>
              )}

              {section.type === 'cta' && (
                <div className="cta-content">
                  <h2>{section.title}</h2>
                  <p>{section.content}</p>
                  {section.buttonText && (
                    <button 
                      className="btn btn-primary btn-large"
                      onClick={() => navigate(section.buttonLink || '/')}
                    >
                      {section.buttonText}
                    </button>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DynamicPage;
